import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-setting-integration-form',
  templateUrl: './setting-integration-form.component.html',
  styleUrls: ['./setting-integration-form.component.scss']
})
export class SettingIntegrationFormComponent {
  public data: any = {status: 1};
  public uuid:any;
  private company_uuid:any;
  public providers:any = []
  public fields:any = []
  public initial_type:any;
  public initial_data:any;
  public selected_provider:any;
  public ggxBalance: string | null = null;
  public ggxBalanceLoading = false;
  constructor(private http: HttpService, private route: ActivatedRoute, private router: Router) {
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    this.company_uuid = this.http.getStaticSelectedCompany();

    uuid.subscribe(async (val) => {
      if(val) {
        this.uuid = val;
        await this.init();
        await this.get(val)
        return;
      }
      await this.init();
    })

  }

  async init() {
    this.providers = await this.http.post("/admin/api-provider/get");

    if(!this.uuid && this.providers.length > 0) {
      this.data.type = this.providers[0].type
      this.selected_provider = this.providers[0]
      this.data.integration_mode = this.selected_provider.integration_mode || 'api'
      this.data.integration = {}
      this.getField();
    }

    
  }

  async getField(event:any = null) {

    if(event && event.target.value) {
      this.data.type = event.target.value;
      this.selected_provider = this.providers.find((provider:any) => provider.type == this.data.type);
      this.data.integration_mode = (this.selected_provider && this.selected_provider.integration_mode) || 'api';

      if(this.initial_type == event.target.value) {
        this.data.integration = JSON.parse(this.initial_data)
      } else {
        this.data.integration = {};
      }
    }

    this.fields = []
    this.fields = await this.http.post("/admin/integration/configuration/v2", {type: this.data.type, integration_mode: this.data.integration_mode});

    if(this.isFggPending()) {
      this.data.status = 0;
    }

    for(var x = 0; x < this.fields.length; x++) {
      let field = this.fields[x];

      if(!this.data.integration[field.key] && field.default) {
        this.data.integration[field.key] = field.default;
      }
    }

  }

  async get(uuid:string) {
    this.data = await this.http.post("/admin/api-integration/get", {api_uuid: uuid});

    if(this.data.type) {
      this.initial_data = JSON.stringify(this.data.integration)
      this.initial_type = String(this.data.type);
      this.selected_provider = this.providers.find((provider:any) => provider.type == this.data.type);
    }

    this.getField();
  }

  async submit() {
    if(this.isCompanyIntegration()) {
      this.data.name = this.data.name || String(this.data.type).toUpperCase();
      this.data.copy_text = null;
    }
    let y:any = await this.http.post("/admin/api-integration/save", this.data);

    if(y.api_uuid) {
      this.router.navigate(["/lo", this.company_uuid, "setting-integration", "form", y.api_uuid])
    }
  }

  async checkGgxBalance() {
    this.ggxBalance = null;
    this.ggxBalanceLoading = true;

    try {
      const result:any = await this.http.post('/admin/integration/ggx/balance', {uuid: this.uuid});
      if (!result || !result.status) {
        this.ggxBalance = result?.message || 'Unable to retrieve the GGX operator balance.';
        return;
      }

      const balance = Number(result.balance);
      this.ggxBalance = Number.isFinite(balance)
        ? `RM ${balance.toLocaleString('en-MY', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
        : 'GGX returned an invalid operator balance.';
    } finally {
      this.ggxBalanceLoading = false;
    }
  }

  isCompanyIntegration() {
    return this.data.integration_mode == 'company';
  }

  isFggPending() {
    return String(this.data.type || '').toLowerCase() === 'fgg';
  }

}
